import { Address } from '../util/address.model';
import { ChurchUnit } from '../ecclesiastical/church-unit.model';
import { Student } from './student.model';

export class StudentListing {
  iNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  privacyMessage: string;
  gender: string;
  isAttending: boolean;
}

export class CheckableStudentListing extends StudentListing {
  checked: boolean;

  constructor(student: StudentListing) {
    super();
    this.iNumber = student.iNumber;
    this.firstName = student.firstName;
    this.lastName = student.lastName;
    this.email = student.email;
    this.privacyMessage = student.privacyMessage;
    this.gender = student.gender;
    this.isAttending = student.isAttending;
    this.checked = false;
  }
}
